import * as L from "leaflet";
import { IBoundLayer, IBoundLayerOptions } from "../../../../map/BoundLayer";
import { UI_ACTIVE_NAIL_SELECTED } from "../../../../redux/modules/ui/reducer";
import {
  getFlightMarkersState,
  getGCPRequestState,
  getSiteState,
} from "../../../../redux/rootReducer";
import { getFlightMarkerById } from "../../../../redux/modules/flightMarkers/flightMarkersReducer";
import config from "../../../../config";
import {
  getFlightMarkerCorruptionStatus,
  getSuggestedFlightMarkerById,
  IGCPRequestState,
} from "../../../../redux/modules/gcpRequest/reducer";
import { convertGlobalToWgs84Coords } from "../../../../utils/coordinateConversion/convertGlobalToWgs84Coords";
import { getSiteSrs } from "../../../../redux/modules/site/reducer";

export default class FlightMarkersNavigator
  extends L.LayerGroup
  implements IBoundLayer
{
  public options: IBoundLayerOptions;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
  }

  public onAdd(map: L.Map) {
    L.LayerGroup.prototype.onAdd.call(this, map);
    this.map = map;
    return this;
  }

  public onRemove(map: L.Map) {
    L.LayerGroup.prototype.onRemove.call(this, map);
    this.map = null;
    return this;
  }

  public update(action: IAction<any>) {
    if (action.type !== UI_ACTIVE_NAIL_SELECTED) {
      return;
    }

    this.map.closePopup();
    const activeFlightMarkerId = action.payload;
    const gcpRequestState = getGCPRequestState(this.options.getState());
    const flightMarkersState = getFlightMarkersState(this.options.getState());
    const srs = getSiteSrs(getSiteState(this.options.getState()));

    if (gcpIsExisting(gcpRequestState, activeFlightMarkerId)) {
      const existingGcp = gcpRequestState.existingGcps.find(
        ({ id }) => id === activeFlightMarkerId,
      );
      if (!existingGcp) {
        throw new Error("Existing GCP was not found");
      }
      const coords = convertGlobalToWgs84Coords(existingGcp.coordinates, srs);
      this.map.setView([coords.y, coords.x], config.existingPointZoom);
      return;
    }

    // Suggested (Blue)
    if (flightMarkerIsSuggested(gcpRequestState, activeFlightMarkerId)) {
      const suggestedFlightMarker = getSuggestedFlightMarkerById(
        gcpRequestState,
        activeFlightMarkerId,
      );

      if (!suggestedFlightMarker) {
        throw new Error("Suggested flight marker was not found");
      }

      this.map.setView(suggestedFlightMarker.coordinates, config.pointZoom);
      return;
    }

    const activeFlightMarker = getFlightMarkerById(
      flightMarkersState,
      activeFlightMarkerId,
    );

    const { x, y } = convertGlobalToWgs84Coords(
      activeFlightMarker.operatorCoords,
      srs,
    );
    this.map.setView([y, x], config.pointZoom);
  }
}

export const flightMarkerIsCorrupted = (
  scanGcpRequestState: IGCPRequestState,
  flightMarkerId: string,
) => !!getFlightMarkerCorruptionStatus(scanGcpRequestState, flightMarkerId);

export const flightMarkerIsSuggested = (
  scanGcpRequestState: IGCPRequestState,
  flightMarkerId: string,
) =>
  !!scanGcpRequestState.suggestedFlightMarkers.find(
    ({ id }) => id === flightMarkerId,
  );

export const gcpIsExisting = (
  scanGcpRequestState: IGCPRequestState,
  gcpId: string,
) => !!scanGcpRequestState.existingGcps.find(({ id }) => id === gcpId);
